import { createFileRoute } from "@tanstack/react-router";

import { OperationsPage } from "../../workspaces/operations/OperationsPage";

export const Route = createFileRoute("/_console/p/$org/$project/operations")({
  component: OperationsPage,
});
